import React, { useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import { CartContext } from "../cart/CartContext";

export default function CheckoutSuccess() {
  useEffect(() => {
    document.title = "Success | Workgear365";
  }, []);
  const { clearCart } = useContext(CartContext);

  useEffect(() => {
    (async () => {
      try {
        // 1) Clear PHP session cart on server
        await api.post("/api/cart/clear");

        // 2) Clear localStorage cart (and any related keys you use)
        localStorage.removeItem("cart");
       // localStorage.removeItem("quote_cart");
        //localStorage.removeItem("coupon");
        clearCart();
        // 3) Clear React cart context
        if (typeof clearCart === "function") clearCart();
      } catch (e) {
        // Even if server call fails, still clear client state
        localStorage.removeItem("cart");
        if (typeof clearCart === "function") clearCart();
        console.error("Failed to clear server cart session", e);
      }
    })();
  }, [clearCart]);

  return (
    <div className="container">
      <style>{`
        #success {
          text-align: center;
          padding: 50px;
          background-color: white;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
          max-width: 600px;
          margin: 50px auto;
        }
        #success h1 {
          color: #28a745;
          font-size: 36px;
          margin-bottom: 16px;
        }
        #success p {
          color: #333;
          font-size: 18px;
          margin-bottom: 24px;
        }
        #success .btn-success-like {
          background-color: #28a745;
          color: #fff;
          padding: 10px 20px;
          text-decoration: none;
          font-size: 16px;
          border-radius: 5px;
          border: none;
          display: inline-block;
          margin: 0 8px;
          transition: background-color 0.3s ease;
        }
        #success .btn-success-like:hover {
          background-color: #218838;
          color: #fff;
        }
      `}</style>

      <div id="success">
        <h1>Payment Successful!</h1>
        <p>Your payment has been successfully processed. Thank you for your purchase!</p>

        {/* Match your Laravel button semantics */}
        {/* Adjust these routes to your React routes */}
        <Link to="/orders" className="btn-success-like">Order Details</Link>
        <Link to="/" className="btn-success-like">Go Home</Link>
      </div>
    </div>
  );
}
